import AdminVenuesPage from './AdminVenuesPage';

/**
 * Dedicated entry point for the "Pending review" venues queue.
 *
 * Renders the same management UI as `/venues/manage` but lands the user
 * pre-filtered to `reviewStatus: 'pending'` (with `active: 'all'` so the
 * inactive pending rows are visible). All filters remain user-editable
 * after mount — this is purely a different starting point.
 */
export default function AdminPendingVenuesPage() {
  return (
    <AdminVenuesPage
      initialFilterOverrides={{ active: 'all', reviewStatus: 'pending' }}
    />
  );
}
